import { useSubscription } from '@apollo/client/react'
import { AppointmentCheckInsSubscriptionDocument } from '@docpace/manager-graphql/dist/urql.types'
import { AppointmentCheckInsSubscriptionResultFragment } from '@docpace/manager-graphql'

export function useAppointmentCheckInsSubscription(opts: useSubscription.Options<AppointmentCheckInsSubscriptionResultFragment>){
    return useSubscription<AppointmentCheckInsSubscriptionResultFragment>(AppointmentCheckInsSubscriptionDocument, opts)
}